<ul class="list-none p-0 m-0 overflow-y-auto" [style.height.svh]="90">
  @for (route of MENU; track route.label) {
  @if (isVisible(route)) {
  @if (!route.children || !route.children.length) {
  <li (mouseenter)="hoveredId.set(route.id)" (mouseleave)="hoveredId.set(-999)">
    <a pRipple
      class="no-underline flex align-items-center cursor-pointer p-3 border-round-xl transition-duration-150 transition-colors p-ripple mx-1"
      [class.justify-content-between]="!isCondensed()" [class.justify-content-center]="isCondensed()"
      [class.active-item]="isActive(route)" [class.inactive-item]="!isActive(route)" [routerLink]="[route.routerUrl]"
      (click)="expandSidebar($event)">
      <div class="flex align-items-center white-space-nowrap overflow-hidden">
        @if (route.icon?.includes('pi ')) {
        <i [style.font-size.px]="18" [class]="(isCondensed() ? '' : 'mr-4 ') + route.icon"></i>
        } @else if (route?.icon?.includes('ci-')) {
        <i [class]="
                    (isCondensed() ? '' : 'mr-4 ') + route.icon + ((isActive(route) || hoveredId() === route.id) ? '__filled' : '')
                  "></i>
        } @else if (route.icon) {
        <ng-icon size="16" [class.mr-4]="!isCondensed()" [name]="route.icon" />
        }
        @if (!isCondensed()) {
        <span class="text-sm select-none text-overflow-ellipsis overflow-hidden" [pTooltip]="route.label | translate"
          tooltipPosition="right">{{
          route.label | translate
          }}</span>
        }
      </div>
      @if (!isCondensed() && route.badgeName && getBadgeValue(route.badgeName) > 0) {
      <p-badge [value]="getBadgeValue(route.badgeName)" severity="warn" />
      }
    </a>
  </li>
  } @else {
  <li (mouseenter)="hoveredId.set(route.id)" (mouseleave)="hoveredId.set(-999)">
    <a pRipple pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-slidedown" leaveToClass="hidden"
      leaveActiveClass="animate-slideup"
      class="no-underline flex align-items-center cursor-pointer p-3 border-round-xl transition-duration-150 transition-colors p-ripple mx-1"
      [class.justify-content-center]="isCondensed()" [class.active-item]="hasActiveChild(route)"
      [class.inactive-item]="!hasActiveChild(route)" (click)="expandSidebar($event)">
      <div class="flex align-items-center white-space-nowrap overflow-hidden">
        @if (route.icon?.includes('pi ')) {
        <i [style.font-size.px]="18" [class]="(isCondensed() ? '' : 'mr-4 ') + route.icon"></i>
        } @else if (route?.icon?.includes('ci-')) {
        <i [class]="
                    (isCondensed() ? '' : 'mr-4 ') +
                    route.icon +
                    ((hasActiveChild(route) || hoveredId() === route.id) ? '__filled' : '')
                  "></i>
        } @else if (route.icon) {
        <ng-icon size="16" [class.mr-4]="!isCondensed()" [name]="route.icon" />
        }
        @if (!isCondensed()) {
        <span class="text-sm select-none text-overflow-ellipsis overflow-hidden" [pTooltip]="route.label | translate"
          tooltipPosition="right">{{
          route.label | translate
          }}</span>
        }
      </div>
    </a>
    <ul
      class="list-none py-0 pl-3 pr-0 m-0 overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out"
      [class.hidden]="!hasActiveChild(route)" [class.condensed-hidden]="isCondensed()">
      @for (subRoute of route.children; track subRoute.label) {
      @if (isVisible(subRoute)) {
      @if (!subRoute.children || !subRoute.children.length) {
      <li (mouseenter)="hoveredId.set(subRoute.id)" (mouseleave)="hoveredId.set(-999)">
        <a pRipple #rla="routerLinkActive"
          class="no-underline flex align-items-center cursor-pointer p-3 border-round-xl transition-duration-150 transition-colors p-ripple mx-1"
          [routerLink]="[subRoute.routerUrl]" routerLinkActive="active-item border-top-2 border-bottom-2 border-white"
          [class.inactive-item]="!rla.isActive">
          <div class="flex align-items-center white-space-nowrap overflow-hidden">
            @if (subRoute.icon?.includes('pi ')) {
            <i [style.font-size.px]="18" [class]="'mr-4 ' + subRoute.icon"></i>
            } @else if (subRoute.icon?.includes('ci-')) {
            <i [class]="
                              'mr-4 ' +
                              subRoute.icon +
                              ((hasActiveChild(subRoute) || hoveredId() === subRoute.id) ? '__filled' : '')
                            "></i>
            } @else if (subRoute.icon) {
            <ng-icon size="16" class="mr-4" [name]="subRoute.icon" />
            }
            <span class="text-sm select-none text-overflow-ellipsis overflow-hidden"
              [pTooltip]="subRoute.label | translate" tooltipPosition="right">{{
              subRoute.label | translate
              }}</span>
          </div>
        </a>
      </li>
      } @else {
      <li (mouseenter)="hoveredId.set(subRoute.id)" (mouseleave)="hoveredId.set(-999)">
        <a pRipple pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-slidedown"
          leaveToClass="hidden" leaveActiveClass="animate-slideup"
          class="no-underline flex align-items-center cursor-pointer p-3 border-round-xl transition-duration-150 transition-colors p-ripple mx-1"
          [class.active-item]="hasActiveChild(subRoute)" [class.inactive-item]="!hasActiveChild(subRoute)"
          (click)="expandSidebar($event)">
          <div class="flex align-items-center white-space-nowrap overflow-hidden">
            @if (subRoute.icon?.includes('pi ')) {
            <i [style.font-size.px]="18" [class]="'mr-4 ' + subRoute.icon"></i>
            } @else if (subRoute.icon?.includes('ci-')) {
            <i [class]="
                              'mr-4 ' +
                              subRoute.icon +
                              ((hasActiveChild(subRoute) || hoveredId() === subRoute.id) ? '__filled' : '')
                            "></i>
            } @else if (subRoute.icon) {
            <ng-icon size="16" class="mr-4" [name]="subRoute.icon" />
            }
            <span class="text-sm select-none text-overflow-ellipsis overflow-hidden"
              [pTooltip]="subRoute.label | translate" tooltipPosition="right">{{
              subRoute.label | translate
              }}</span>
          </div>
        </a>
        <ul
          class="list-none py-0 pl-3 pr-0 m-0 overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out"
          [class.hidden]="!hasActiveChild(subRoute)" [class.condensed-hidden]="isCondensed()">
          @for (
          subSubRoute of subRoute.children;
          track subSubRoute.label
          ) {
          @if (isVisible(subSubRoute)) {
          <li (mouseenter)="hoveredId.set(subSubRoute.id)" (mouseleave)="hoveredId.set(-999)">
            <a pRipple #rla="routerLinkActive"
              class="no-underline flex align-items-center cursor-pointer p-3 border-round-xl transition-duration-150 transition-colors p-ripple mx-1"
              [routerLink]="[subSubRoute.routerUrl]"
              routerLinkActive="active-item border-top-2 border-bottom-2 border-white"
              [class.inactive-item]="!rla.isActive" (click)="expandSidebar($event)">
              <div class="flex align-items-center white-space-nowrap overflow-hidden">
                @if (subSubRoute.icon?.includes('pi ')) {
                <i [style.font-size.px]="18" [class]="'mr-4 ' + subSubRoute.icon"></i>
                } @else if (subSubRoute.icon?.includes('ci-')) {
                <i [class]="
                                      'mr-4 ' +
                                      subSubRoute.icon +
                                      ((hasActiveChild(subSubRoute) || hoveredId() === subSubRoute.id)
                                        ? '__filled'
                                        : '')
                                    "></i>
                } @else if (subSubRoute.icon) {
                <ng-icon size="16" class="mr-4" [name]="subSubRoute.icon" />
                }
                <span class="text-sm select-none text-overflow-ellipsis overflow-hidden"
                  [pTooltip]="subSubRoute.label | translate" tooltipPosition="right">{{
                  subSubRoute.label | translate
                  }}</span>
              </div>
            </a>
          </li>
          }
          }
        </ul>
      </li>
      }
      }
      }
    </ul>
  </li>
  }
  }
  }
</ul>